import { Box } from '../types';

export const sampleBoxes: Box[] = [
  {
    id: '1',
    length: 35,
    width: 25,
    height: 20,
    quantity: 100,
    asin: 'B08N5WRWNW'
  },
  {
    id: '2',
    length: 40,
    width: 20,
    height: 30,
    quantity: 80,
    asin: 'B07ZPKBL9V'
  },
  {
    id: '3',
    length: 50,
    width: 30,
    height: 15,
    quantity: 60,
    asin: 'B09B3ZXF5L'
  },
  {
    id: '4',
    length: 30,
    width: 20,
    height: 25,
    quantity: 120,
    asin: 'B08N5WRWNW'
  },
  {
    id: '5',
    length: 45,
    width: 35,
    height: 18,
    quantity: 90,
    asin: 'B07ZPKBL9V'
  }
]; 